<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false
  },
  initialAnimation: {
    type: Boolean,
    default: false
  }
})

const isVisible = ref(props.isOpen && !props.initialAnimation)

watch(() => props.isOpen, (open) => {
  if (!props.initialAnimation) {
    isVisible.value = open
  }
})

const toggleView = () => {
  isVisible.value = !isVisible.value
}

defineExpose({ toggleView, isVisible })
</script>
<template>
  <!-- TODO fix animation -->
  <!-- enter-active-class="transition-all duration-300 ease-in-out"
    enter-from-class="max-h-0 opacity-0"
    enter-to-class="max-h-[500px] opacity-100"
    leave-active-class="transition-all duration-300 ease-in-out"
    leave-from-class="max-h-[500px] opacity-100"
    leave-to-class="max-h-0 opacity-0" -->
  <!-- <Transition
  > -->
    <section v-if="isVisible" class="collapse-wrapper overflow-hidden">
      <slot />
    </section>
  <!-- </Transition> -->
</template>

<style scoped>
/* Removed previous CSS animations as they're now handled by Tailwind */
</style>